import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyVehicleType = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        if(props.restrictSearch){
            ReadAxios({ url: 'vehicleTypeMaster'})
                .then((result) => {
                    result?.data?.resultSet?.length && setcontent(result?.data?.resultSet) ;
                    setloading(false)
                })
        }
        // $("#searchType .dropdown").removeClass("dropdown")
    }, [])
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ url: 'vehicleTypeMaster', readItems: { searchTerm: searchTerm } })
                .then((result) => {
                    result?.data?.resultSet?.length && setcontent(result?.data?.resultSet) ;
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleTypeCode
            temp.text = object.vehicleType
            temp.value = object.vehicleTypeId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search={props.restrictSearch ? false : true}
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyVehicleType